<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
   <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
   <z-page :title="title">
    <div class="w-card__content content-hardcode">
        <div class="w-flex wrap smd-column" >
        <div class="grow " >
        <z-select style="margin:5px; " class="mt4" outline :items="premis" label="ID / Nama Premis *"  v-model="form.premis_id" @input="getTernakan(form)" :validators="[validators.required]" />
        <br>
           <div class="w-flex wrap smd-column" >
      <div class="grow " >
          <div style="margin:5px;padding-left: 5px;" class="fw-normal my1 fs-1"><b> Pasung : </b>
            <w-radios
                class="mr2"
                v-model="form.pasung"
                :items="pasung_list"
                inline
                color="blue-light1">
              </w-radios></div>
          </div>
        </div>
        </div>
        <div class="mx2"></div>
        <div class="grow " >
         <!--  <template v-if="form.lkp_negeri_id">
             <div style="margin:17px;" class="fw-normal my1 fs-1"><b>Negeri : </b>{{form.lkp_negeri}}</div>
          </template> -->
          <!-- <w-input style="margin:5px; " class="mt4" :items="lkp_negeri" label="Negeri"  v-model="form.lkp_negeri_id" :validators="[validators.required]"  /> -->
      </div>
    </div>
    <br>
     <div class="notice-container">
            <div class="notice-icon">
              <w-icon class="notice-icon-symbol">fal fa-exclamation-triangle</w-icon>
            </div>
            <div class="notice-content">
              <h3 class="notice-title">Penting</h3>
              <p class="notice-message">Sila hubungi Jurusuntik/Juruteknik yang dipilih sebelum menghantar permohonan</p>
            </div>
          </div>
    </div>
    <br>
    <div class="w-card__content content-hardcode">
    <div class="w-flex wrap smd-column" >
      <div class="grow " >
         <z-select class="mt4" outline :items="lkp_negeri" label="Negeri Juruteknik *"  v-model="form.lkp_negeri_id" @input="getJuruteknik(form)"  :validators="[validators.required]"/>
        <z-select class="mt4"  outline :items="lkp_tujuan" label="Tujuan PD*" v-model="form.lkp_tujuan_id" @input="getTernakan(form)" :validators="[validators.required]"/>

        <!-- <template v-if="form.lkp_tujuan_id == 1">
             <z-select class="mt4"  outline :items="art_pd" label="No Kes*" v-model="form.art_id" @input="getTernakan(form)"  :validators="[validators.required]"/>
        </template> -->
        <w-input class="mt4" type="date" outline label="Tarikh Temujanji PD *" v-model="form.tarikh_datang_pemeriksaan" :min="tarikh_today" :validators="[validators.required]" ></w-input>
      </div>
      <div class="mx2"></div>
      <div class="grow " >
        <z-select
            class="mt4"
            outline
            label="Nama Juruteknik/Jurusuntik *"
            :items="juruteknik_list"
            v-model="form.juruteknik_id"
            :validators="[validators.required]"
            @mousedown.prevent="Jurus(form)"
         />
        <z-select class="mt4" outline :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form.lkp_ternakan_id" @input="getTernakan(form);getJuruteknik(form);" :validators="[validators.required]"/>
      </div>
    </div>
    <br>

    <!-- CARIAN FILTER UNTUK JADUAL UTAMA (SAMA SEPERTI AI) -->
    <div class="filter-container">
      <div class="filter-wrapper">
        <div class="filter-input-group">
          <w-input
            class="filter-input"
            placeholder="Carian ID Ternakan atau Nama Ternakan..."
            v-model="filter_carian"
            clearable
            @input="filterTernakanList">
            <template #prepend>
              <w-icon>fal fa-search</w-icon>
            </template>
          </w-input>
          <w-button
            v-if="filter_carian"
            class="clear-filter-btn ml1"
            @click="clearFilter"
            outline
            small>
            <w-icon class="mr1">fal fa-times</w-icon> Clear
          </w-button>
        </div>
        <div v-if="filter_carian && ternakan_list_original && ternakan_list_original.length" class="filter-info">
          <span class="badge-filter">
            <w-icon class="mr1">fal fa-search</w-icon>
            Ditemui: {{ (filtered_ternakan_list || []).length }} daripada {{ (ternakan_list_original || []).length }} rekod
          </span>
        </div>
      </div>
    </div>


    <w-alert v-if="!hasTernakan && form.lkp_tujuan_id" error class="my3" no-border>
      Tiada ternakan untuk meneruskan permohonan PD bagi tujuan {{getTujuanName(form.lkp_tujuan_id)}}
    </w-alert>

    <div class="modern-table-container" style="max-height: 400px;">
     <div class="table-scroll-wrapper">
       <table class="modern-table">
         <thead>
            <tr>
              <th class="table-header text-left" width="1%">BIL</th>
              <th class="table-header text-left">NO. PENDAFTARAN</th>
              <th class="table-header text-left">ID | NAMA TERNAKAN</th>

              <!-- Kolom khusus tujuan PD (tidakBuntingArt) -->
              <template v-if="form.lkp_tujuan_id == 1">
                <th class="table-header text-left">NO KES AI/ET</th>
                <th class="table-header text-left">TARIKH SUNTIKAN</th>
              </template>

              <th class="table-header text-left">JANTINA</th>
              <th class="table-header text-left">UMUR (BULAN)</th>
              <th class="table-header text-left">BAKA</th>
              <template v-if="form.lkp_tujuan_id == 1">
              <th class="table-header text-left">STATUS</th>
              <th class="table-header text-left">STATUS TERNAKAN</th>
                </template>
                <template v-else>
              <th class="table-header text-left">STATUS</th>
              </template>

              <!-- Tujuan lain: kekalkan tarikh beranak -->
              <template v-if="form.lkp_tujuan_id != 1">
                <th class="table-header text-left">TARIKH SUNTIKAN</th>
                <th class="table-header text-left">TARIKH BERANAK</th>
              </template>

              <th class="table-header text-center">
                <w-checkbox v-model="checkin" @change="klickPilih()" class="header-checkbox"></w-checkbox>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="!filtered_ternakan_list || filtered_ternakan_list.length == 0">
              <tr class="table-row">
                <td class="table-cell text-center" :colspan="form.lkp_tujuan_id == 1 ? 10 : 11">
                  <div class="no-data">
                    <w-icon class="mr2">fal fa-inbox</w-icon>
                    <span v-if="filter_carian">Tiada hasil carian untuk "{{ filter_carian }}"</span>
                    <span v-else>Tiada Data.</span>
                  </div>
                </td>
              </tr>
            </template>

            <template v-for="(dt, ind) in filtered_ternakan_list" :key="dt.ternakan_id || ind">
              <tr class="table-row" :class="{ 'row-hover': true, 'highlight-match': isMatchFilter(dt) }">
                <td class="table-cell text-left">{{ ind + 1 }}</td>


                <td class="table-cell text-left">{{ dt.kode || '-' }}</td>


                <td class="table-cell text-left" style="text-transform: uppercase;">
                  <span v-html="highlightText((dt.id_ternakan || '-') + ' | ' + (dt.nama_ternakan || ''))"></span>
                </td>


                <template v-if="form.lkp_tujuan_id == 1">
                  <td class="table-cell text-left">{{ dt.no_kes || '-' }}</td>
                  <td class="table-cell text-left">{{ $zutil.dateformat(dt.tarikh_suntik) || '-' }}</td>
                </template>

                <td class="table-cell text-left">{{ dt.jantina || '-' }}</td>
                <td class="table-cell text-left">{{ $zutil.umurBln(dt.tarikh_lahir) || 0 }}</td>
                <td class="table-cell text-left">{{ dt.baka || '-' }}</td>
                <template v-if="form.lkp_tujuan_id == 1">
                    <td class="table-cell text-left">{{ dt.art_ternakan.lkp_status_nama || '-' }}</td>
                    <td class="table-cell text-left">{{ dt.status || '-' }}</td>
                </template>
                <template v-else><td class="table-cell text-left">{{ dt.status || '-' }}</td></template>


                <!-- Tujuan lain -->
                <template v-if="form.lkp_tujuan_id != 1">
                  <td class="table-cell text-left">{{ $zutil.dateformat(dt.tarikh_suntik) }}</td>
                  <td class="table-cell text-left">
                    <div v-if="!dt.tarikh_beranak" class="empty-data">-</div>
                    <div v-else>{{ $zutil.dateformat(dt.tarikh_beranak) }}</div>
                  </td>
                </template>
                <td class="table-cell text-center">
                    <template v-if="form.lkp_tujuan_id == 1">
                        <template v-if="dt.sudah_pilih == 0 || (dt.art_ternakan && dt.sudah_pilih == 2 && dt.art_ternakan.id_art == form.id)">
                            <w-checkbox v-model="dt.pilih" class="row-checkbox"></w-checkbox>
                        </template>
                    </template>
                    <template v-else>
                        <w-checkbox v-model="dt.pilih" class="row-checkbox"></w-checkbox>
                    </template>
                </td>
              </tr>
            </template>
          </tbody>
       </table>
     </div>
   </div>
      <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '2', '5', '4'])">
                 <w-button class="my1" :loading="form.submitted && !form.sent" @click="send(2); onSuccess()" :disabled="!hasTernakan">
                      <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
                 </w-button>
               &nbsp;
                  <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false || !hasTernakan" :loading="form.submitted && !form.sent" @click="send(1)">
                    <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
                 </w-button>
      </w-flex>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0;
                  border: 2px solid red;
                  color: #333;
                  padding: 7px 14px;
                  font-size: 10px;
                  font-weight: bold;
                  border-radius: 4px;
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
    </div>
 </z-page>
    </w-form>

    <!-- Dialog Carian Juruteknik -->
    <w-dialog
          v-model="dialog.show"
          :fullscreen="dialog.fullscreen"
          width="800"
          :persistent="dialog.persistent"
          :persistent-no-animation="dialog.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                  CARIAN JURUTEKNIK
        </template>
         <w-flex justify-center align-center>
                      <div class="xs8">
                             <w-input label="Nama Juruteknik (Carian minimum 2 aksara)" v-model="carian_juru.q"> </w-input>
                      </div>
                      <div class="xs4">
                            <w-button class="ml1" @click="getJuruteknik(form)">Cari</w-button>
                      </div>
                  </w-flex>
                  <br>
                  <br>
            <div class="w-table-wrap" style="max-height: 400px;">
              <div class="table-profil-scrol">
                <table class="w-table ">
                    <thead>
                      <tr>
                          <th class="w-table__header w-table__header--sortable text-left">No</th>
                          <th class="w-table__header w-table__header--sortable text-left"> Nama</th>
                          <th class="w-table__header w-table__header--sortable text-left"> Jenis</th>
                          <th class="w-table__header w-table__header--sortable text-left"> Pilih</th>
                      </tr>
                    </thead>
                    <tbody>
                          <tr v-for="(dt, index) in juruteknik_list" :key="index">
                              <td class="w-table__cell text-left">
                                  {{(index+1)}}
                               </td>
                              <td class="w-table__cell ">
                                  {{dt.label}}
                               </td>
                              <td class="w-table__cell ">
                                  {{dt.jenis_pengguna}}
                               </td>
                              <td class="w-table__cell text-right">
                                  <w-radio class="mr2" v-model="form.juruteknik_id" :return-value="dt.value" @click="dialog.show = false"></w-radio>
                               </td>
                           </tr>
                    </tbody>
                   </table>
              </div>
            </div>
        <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0;
                  border: 2px solid red;
                  color: #333;
                  padding: 7px 14px;
                  font-size: 10px;
                  font-weight: bold;
                  border-radius: 4px;
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
         </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'art.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Permohonan', route: '/art' },
        { label: 'Pemeriksaan Kebuntingan PD', route: '/art/permohonan' },
      ],
      title : 'PD Permohonan',
      form : this.d_form,
      lkp_negeri : this.d_lkp_negeri,
      pasung_list:[
        {value: 1, label: "Ada"},
        {value: 2, label: "Tiada"},
      ],
      negeri:'',
      ternakan_list: [],
      ternakan_list_original: [],
      filtered_ternakan_list: [],
      filter_carian: '',
      premis : [],
      juruteknik_list : [],
      lkp_tujuan: [],
      art_pd: [],
      lkp_ternakan : [],
      lkp_status : [],
      lkp_art : [],
      loading : 0,
      checkin:false,
      tarikh_today: '',
      carian_juru : {q: ''},
      hasTernakan: true,
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        item: {}
      }
    }
  },
  methods: {
    // Filter functions (sama seperti AI)
    filterTernakanList() {
      try {
        if (!this.filter_carian || this.filter_carian.trim() === '') {
          this.filtered_ternakan_list = this.ternakan_list_original ? [...this.ternakan_list_original] : [];
          return;
        }

        const searchTerm = this.filter_carian.toLowerCase().trim();
        const originalList = this.ternakan_list_original || [];

        this.filtered_ternakan_list = originalList.filter(item => {
          if (!item) return false;
          const namaTernakan = (item.nama_ternakan || '').toLowerCase();
          const kode = (item.kode || '').toLowerCase();
          const noKes = (item.no_kes || '').toLowerCase();
          const idTernakan = (item.id_ternakan || '').toLowerCase(); // ada jika backend diupdate

          return namaTernakan.includes(searchTerm) ||
                 kode.includes(searchTerm) ||
                 noKes.includes(searchTerm) ||
                 idTernakan.includes(searchTerm);
        });
      } catch (error) {
        console.error('Error filtering:', error);
        this.filtered_ternakan_list = this.ternakan_list_original ? [...this.ternakan_list_original] : [];
      }
    },

    isMatchFilter(item) {
      if (!this.filter_carian || !item) return false;
      const searchTerm = this.filter_carian.toLowerCase().trim();
      const namaTernakan = (item.nama_ternakan || '').toLowerCase();
      const kode = (item.kode || '').toLowerCase();
      const noKes = (item.no_kes || '').toLowerCase();
      return namaTernakan.includes(searchTerm) ||
             kode.includes(searchTerm) ||
             noKes.includes(searchTerm);
    },

    highlightText(text) {
      if (!this.filter_carian || !text) return text;

      try {
        const searchTerm = this.filter_carian.toLowerCase().trim();
        const textLower = text.toLowerCase();

        if (textLower.includes(searchTerm)) {
          const regex = new RegExp(`(${this.escapeRegExp(searchTerm)})`, 'gi');
          return text.replace(regex, '<span class="highlight-text">$1</span>');
        }
        return text;
      } catch (error) {
        return text;
      }
    },

    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    clearFilter() {
      this.filter_carian = '';
      this.filtered_ternakan_list = this.ternakan_list_original ? [...this.ternakan_list_original] : [];
    },

    Jurus(form){
      this.dialog.show = true;
      this.form.saveButton = "Simpan"
    },

    send(hantar){
      this.form.hantar = hantar
    },

    validateForm() {
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
      for (var i in this.ternakan_list) {
        if(this.ternakan_list[i].pilih==true){
          jumlah_lulus = 1;
        }
      };
      if(!this.form.premis_id || !this.form.juruteknik_id || !this.form.lkp_ternakan_id || !this.form.tarikh_datang_pemeriksaan){
        isValid = false;
      }
      if(jumlah_lulus == 0 && isValid == true){
        isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah dipilih", false);
        this.loading=false;
        return false;
      }
      this.onSuccess();
    },

    getTujuanName(tujuanId) {
      const tujuan = this.lkp_tujuan.find(item => item.value === tujuanId);
      return tujuan ? tujuan.label : '';
    },

    klickPilih(){
      for (var b in this.ternakan_list) {
        this.ternakan_list[b].pilih = this.checkin
      }
    },

    onSuccess(){
      this.form.ternakan_list = this.ternakan_list;
      this.form.permohonan = 1;
      if(this.form.hantar == 1){
        this.$swal({
          title: 'Anda Pasti?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (this.form.id > 0){
              this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
              .then(res => {
                if (typeof this.onAfterEdit === "function") this.onAfterEdit()
                if (this.form.hantar==1) this.$inertia.visit(this.$route('art.semakan.index'));
                else this.$zutil.notify("Berjaya disimpan", true);
              })
            } else {
              this.$zcomm.post(this.resourceurl+'.store', this.form)
              .then(res => {
                if (typeof this.onAfterAdd === "function") this.onAfterAdd()
                this.$zutil.notify("Berjaya dihantar", true);
                this.$inertia.visit(window.route('art.semakan.index', res.id));
              })
            }
          }
        })
      } else {
        if (this.form.id > 0) {
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") this.onAfterEdit()
            if (this.form.hantar==1) this.$inertia.visit(this.$route('art.semakan.index'));
            else {
              this.$zutil.notify("Berjaya disimpan", true);
              this.$inertia.visit(this.$route('art.permohonan.pd', this.form.id));
            }
          })
        } else {
          this.$zcomm.post(this.resourceurl+'.store', this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") this.onAfterAdd()
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('art.permohonan.pd', res.id));
          })
        }
      }
    },

    getPremis(){
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res
        if (this.premis.length == 1) {
          for (var p in this.premis) {
            this.form.premis_id = this.premis[p].value;
            this.form.lkp_negeri_id = this.premis[p].lkp_negeri_id;
            this.form.lkp_negeri = this.premis[p].lkp_negeri;
          }
        }
      }).catch(err => console.error('Error loading premis:', err));
    },

    getData(){

      if (this.form.lkp_tujuan_id) {
        this.form.art_id = this.getArtIdForTujuan();
      }
      this.getTernakan(this.d_form);
      this.getJuruteknik(this.d_form);
    },

        getTernakan(data){
      this.hasTernakan = true;

      if(data.premis_id != '' && data.lkp_ternakan_id != '' && data.lkp_tujuan_id != ''){

        let url = '';


        if (data.lkp_tujuan_id == 1) {
          const artId = data.art_id || this.getArtIdForTujuan();
          url = this.api_service + 'ternakan/tidak_bunting_art/'
                + data.premis_id + '/'
                + data.lkp_ternakan_id + '/'
                + artId;
        } else {
          url = this.api_service + 'ternakan/tidak_bunting/'
                + data.premis_id + '/'
                + data.lkp_ternakan_id + '/'
                + data.lkp_tujuan_id;
        }

        this.$zcomm.get(url, {}).then(res => {
          this.ternakan_list_original = res || []
          this.ternakan_list = res || []
          this.filtered_ternakan_list = res || []
          this.hasTernakan = this.ternakan_list.length > 0;

          if (!this.hasTernakan) {
            const tujuanName = this.getTujuanName(data.lkp_tujuan_id);
            this.$zutil.notify(`Tiada ternakan untuk meneruskan permohonan PD bagi tujuan ${tujuanName}`, false);
          }


          if(data.ternakan_list && data.ternakan_list.length > 0){
            for (let i in this.ternakan_list) {
              for (let t in data.ternakan_list) {
                if(this.ternakan_list[i] && data.ternakan_list[t] &&
                   this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                  this.ternakan_list[i].pilih = true
                }
              }
            }
          }
        }).catch(err => console.error('Error loading ternakan:', err));
      }

      // Cari negeri premis & juruteknik
      for (let b in this.premis) {
        if(this.premis[b].value == data.premis_id){
          this.form.lkp_negeri_id = this.premis[b].lkp_negeri_id;
          this.form.lkp_negeri = this.premis[b].lkp_negeri;
          this.getJuruteknik(data);
        }
      }
    },

      getArtIdForTujuan() {

      const artMapping = {
        1: 1,   // PD  → ART AI

      };
      return artMapping[this.form.lkp_tujuan_id] || 1;
    },

    getJuruteknik(data){
      if(data.lkp_negeri_id !='' && data.lkp_art_id !=''){
        if(data.lkp_tujuan_id !=5 && data.lkp_tujuan_id !=6){
          this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+data.lkp_negeri_id+'/2/0', this.carian_juru, {}).then(res => {
            this.juruteknik_list = res || []
          }).catch(err => console.error('Error loading juruteknik:', err));
        } else {
          this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+data.lkp_negeri_id+'/2/1', this.carian_juru, {}).then(res => {
            this.juruteknik_list = res || []
          }).catch(err => console.error('Error loading juruteknik:', err));
        }
      }
    },

    getJenisTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res || []
      }).catch(err => console.error('Error loading jenis ternakan:', err));
    },

    getTujuanPd(){
      this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
        this.lkp_tujuan = res || []
      }).catch(err => console.error('Error loading tujuan:', err));
    },

    getArtPd(){
      this.$zcomm.get(this.api_service + 'lookup/art_pd', {}).then(res => {
        this.art_pd = res || []
      }).catch(err => console.error('Error loading art pd:', err));
    },

    tutup(){
      this.$inertia.visit(window.route('art.semakan.index'));
    },
  },

  mounted() {
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    this.title = 'Tambah Permohonan Perkhidmatan Pemeriksaan Kebuntingan (PD)'
    this.getTujuanPd()
    this.getPremis()
    this.getJenisTernakan()
    this.getArtPd()
    this.getData()
  }
}
</script>

<style scoped>
.filter-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #f8f9fa 100%);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  border: 1px solid #e0e6ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filter-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-input {
  flex: 1;
}

.clear-filter-btn {
  white-space: nowrap;
}

.filter-info {
  margin-top: 8px;
}

.badge-filter {
  display: inline-flex;
  align-items: center;
  background-color: #e8f0f5;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  color: #2c7da0;
  font-weight: 500;
}

.highlight-match {
  background-color: #fff3cd !important;
}

.highlight-text {
  background-color: #ffeb3b;
  color: #333;
  font-weight: bold;
  padding: 0 2px;
  border-radius: 3px;
}

.modern-table-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  border: 1px solid #eaeaea;
  margin-bottom: 16px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  max-height: 400px;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.table-scroll-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 4px;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.table-header {
  background-color: #f8f9fa;
  padding: 16px 12px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #eaeaea;
  position: sticky;
  top: 0;
  z-index: 10;
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.table-row:nth-child(even) {
  background-color: #fbfcfd;
}

.table-row:nth-child(even):hover {
  background-color: #f0f4f8;
}

.table-cell {
  padding: 14px 12px;
  font-size: 0.9rem;
  color: #333;
  vertical-align: middle;
}

.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #888;
  font-size: 1rem;
}

.empty-data {
  color: #999;
  font-style: italic;
}

.header-checkbox, .row-checkbox {
  transform: scale(1.1);
}

.notice-container {
  display: flex;
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 8px;
  padding: 16px;
}

.notice-icon {
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice-icon-symbol {
  font-size: 1.5rem;
  color: #856404;
}

.notice-content {
  flex-grow: 1;
}

.notice-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #856404;
}

.notice-message {
  margin: 0;
  color: #856404;
}

.mt1 { margin-top: 4px; }
.mt2 { margin-top: 8px; }
.mt3 { margin-top: 16px; }
.ml1 { margin-left: 8px; }
.mr1 { margin-right: 8px; }

@media (max-width: 768px) {
  .table-header {
    font-size: 0.75rem;
    padding: 12px 8px;
  }

  .table-cell {
    font-size: 0.8rem;
    padding: 10px 8px;
  }
}
</style>
